import { render, staticRenderFns } from "./Premiums.vue?vue&type=template&id=343ff500&scoped=true&lang=pug"
import script from "./Premiums.vue?vue&type=script&lang=js"
export * from "./Premiums.vue?vue&type=script&lang=js"
import style0 from "./Premiums.vue?vue&type=style&index=0&id=343ff500&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "343ff500",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/home/docker/code/frontend/components/Icon.vue').default})
